import * as TG from '@radix-ui/react-toggle-group'

import { cn } from '@/libs/tw'

import { fontStyles } from '../typography/typographyUtils'

type ToggleGroupProps = {
	value?: string
	items: string[]
	description: string
	style?: 'default' | 'inverted'
	direction?: 'horizontal' | 'vertical'
	alignment?: 'left' | 'center' | 'right'
	onSelect: (value?: string) => void
}

export const ToggleGroup = ({
	value,
	items,
	description,
	style = 'default',
	direction = 'horizontal',
	alignment = 'center',
	onSelect,
}: ToggleGroupProps) => (
	<TG.Root
		className={cn(
			'flex flex-wrap gap-8',
			alignment === 'left' &&
				(direction === 'horizontal' ? 'flex-row justify-start' : 'flex-col items-start'),
			alignment === 'center' &&
				(direction === 'horizontal' ? 'flex-row justify-center' : 'flex-col items-center'),
			alignment === 'right' &&
				(direction === 'horizontal' ? 'flex-row justify-end' : 'flex-col items-end')
		)}
		type="single"
		value={value}
		aria-label={description}
		data-testid={description}
		onValueChange={(value?: string) => onSelect(value)}
	>
		{items.map((item) => (
			<TG.Item
				key={item}
				className={cn(
					'rounded-24 border px-16 py-6 capitalize md:px-32  md:py-8',
					style === 'default' &&
						'border-toggleGroup-secondary text-toggleGroup-secondary',
					style === 'inverted' &&
						'border-toggleGroup-invertedPrim text-toggleGroup-invertedPrim',
					value === item &&
						style === 'default' &&
						'bg-toggleGroup-secondary text-toggleGroup-primary',
					value === item &&
						style === 'inverted' &&
						'bg-toggleGroup-invertedPrim text-toggleGroup-invertedSec',
					fontStyles['p']
				)}
				value={item}
				aria-label={item}
			>
				{item}
			</TG.Item>
		))}
	</TG.Root>
)
